export default "__VITE_ASSET__7164b740__"